// AIMA on-chain configuration — Arbitrum One
// Official contract addresses & ABI provided by the AIMA team.
import AIMA_SALE_ABI_JSON from "./aimaSaleAbi.json";

export const AIMA_CONFIG = {
    chain: {
        id: Number(process.env.REACT_APP_CHAIN_ID),
        name: "Arbitrum One",
        explorer: "https://arbiscan.io",
    },
    contracts: {
        aimaToken: process.env.REACT_APP_AIMA_TOKEN,
        aimaSale: process.env.REACT_APP_AIMA_SALE,
        aimaVesting: process.env.REACT_APP_AIMA_VESTING,
        safeTreasury: process.env.REACT_APP_SAFE_TREASURY,
    },
    paymentTokens: {
        USDC: {
            symbol: "USDC",
            address: process.env.REACT_APP_USDC_ADDRESS,
            decimals: 6,
            label: "USDC (Arbitrum One)",
        },
        USDT: {
            symbol: "USDT",
            address: process.env.REACT_APP_USDT_ADDRESS,
            decimals: 6,
            label: "USDT / USD₮0 (Arbitrum One)",
        },
    },
};

// Minimal ERC-20 ABI — approve + allowance + decimals + balanceOf
export const ERC20_ABI = [
    { type: "function", name: "approve", stateMutability: "nonpayable", inputs: [{ name: "spender", type: "address" }, { name: "amount", type: "uint256" }], outputs: [{ type: "bool" }] },
    { type: "function", name: "allowance", stateMutability: "view", inputs: [{ name: "owner", type: "address" }, { name: "spender", type: "address" }], outputs: [{ type: "uint256" }] },
    { type: "function", name: "decimals", stateMutability: "view", inputs: [], outputs: [{ type: "uint8" }] },
    { type: "function", name: "balanceOf", stateMutability: "view", inputs: [{ name: "owner", type: "address" }], outputs: [{ type: "uint256" }] },
];

// Official AIMASale ABI (from AIMASale.json → abi field).
export const AIMA_SALE_ABI = AIMA_SALE_ABI_JSON;
